import { CheckIcon } from '@heroicons/react/20/solid'
import { Link } from 'react-router-dom'
import Titlebar from './Titlebar'
import { apiUrl } from './config';

const tiers = [
  {
    name: 'Gold',
    id: 'gold',
    href: apiUrl('/sales/ordertemplate?templateName=gold'),
    price: '$500',
    description: 'Average Frequency',
    features: ['Coverage throughout week', 
               'Drive Time Emphasis', 
               'Occasional Weekends', 
               'A la carte pricing on Remote and Event Packages',],
    mostPopular: false,
    classes: 'bg-orange-100',
    buttonBackground: 'bg-orange-300'
  },
  {
    name: 'Platinum',
    id: 'platinum',
    href: apiUrl('/sales/ordertemplate?templateName=platinum'),
    price: '$750',
    description: 'Moderate Frequency',
    features: ['Coverage throughout week', 
               'Drive Time Emphasis', 
               'Occasional Weekends', 
               'Optional Remotes',
               'Optional Event Packages',],
    mostPopular: true,
    classes: 'bg-gray-100',
    buttonBackground: 'bg-gray-300'
  },
  {
    name: 'Multi-Platinum',
    id: 'multi-platinum',
    href: apiUrl('/sales/ordertemplate?templateName=multi-platinum'),
    price: '$1000',
    description: 'High Frequency',
    features: ['Coverage throughout week', 'Drive Time Emphasis', 'Including Weekends', 'Bonus Coverage at No Charge'],
    mostPopular: false,
    classes: 'bg-red-100',
    buttonBackground: 'bg-red-300'
  },
  {
    name: 'Diamond',
    id: 'diamond',
    href: apiUrl('/sales/ordertemplate?templateName=diamond'),
    price: '$1500',
    description: 'Very High Frequency',
    features: ['Coverage throughout week', 'Drive Time Emphasis', 'Including Weekends', 'Bonus Coverage at No Charge', '1 Remote per month'],
    mostPopular: false,
    classes: 'bg-blue-100',
    buttonBackground: 'bg-blue-300'
  },
]

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

function PackageForm() {  
  return (
    <div className="lg:pl-72 sm:ml-0 px-0 sm:px-0">

      <Titlebar title="Packages"/>

    <div className="bg-white py-8 sm:py-16">
      <div className="mx-auto max-w-7xl px-3 lg:px-4">
        <div className="mx-auto max-w-4xl text-center">
          <p className="mt-1 text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl">
            Plan sales campaigns of&nbsp;all&nbsp;sizes
          </p>
        </div>
        <p className="mx-auto mt-6 max-w-2xl text-center text-lg leading-8 text-gray-600">
          Choose an affordable plan that’s packed with the best features for engaging your audience, creating customer
          loyalty, and driving revenue for your business.
        </p>
        <div className="mx-auto mt-10 grid max-w-md grid-cols-1 gap-8 md:max-w-2xl md:grid-cols-2 lg:max-w-4xl xl:mx-0 xl:max-w-none xl:grid-cols-4">
          {tiers.map((tier) => (
            <div
              key={tier.id}
              // append a background class to the className
              className={classNames(
                tier.mostPopular ? 'ring-2 ring-indigo-600 ' + tier.classes : 'ring-1 ring-gray-400',
                'rounded-3xl p-8 ' + tier.classes
              )}
            >
              <h3
                id={tier.id}
                className={classNames(
                  tier.mostPopular ? 'text-indigo-600' : 'text-gray-900',
                  'text-lg font-semibold leading-8'
                )}
              >
                {tier.name}
              </h3>
              <p className="mt-4 text-sm leading-6 text-gray-600">{tier.description}</p>
              <p className="mt-6 flex items-baseline gap-x-1">
                <span className="text-4xl font-bold tracking-tight text-gray-900">{tier.price}</span>
                <span className="text-sm font-semibold leading-6 text-gray-600">/mo</span>
              </p>
              <Link to={`/orderentry/${tier.id}`}
                aria-describedby={tier.id}
                className={classNames(
                  tier.mostPopular
                    ? 'bg-indigo-600 text-white shadow-sm hover:bg-indigo-500'
                    : 'text-black-600 ring-1 ring-inset ring-indigo-200 hover:ring-indigo-300 ' + tier.buttonBackground,
                  'mt-6 block rounded-md py-2 px-3 text-center text-sm font-semibold leading-6 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600'
                )}
              >
                Buy plan
              </Link>
              <ul className="mt-8 space-y-3 text-sm leading-6 text-gray-600">
                {tier.features.map((feature) => (
                  <li key={feature} className="flex gap-x-3">
                    <CheckIcon className="h-6 w-5 flex-none text-indigo-600" aria-hidden="true" />
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </div>
    </div>
  )
}

export default PackageForm;